import type { HTMLAttributeAnchorTarget, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import type { To } from 'react-router';
import { ConfigProvider } from '../config-provider';
import { Link } from '../link';

type P = {
  className?: string;
  onClick?: () => Promise<void> | void;
  target?: HTMLAttributeAnchorTarget;
  text: string;
  to: To;
};

const MenuLinkItem = ({ className, onClick, target, text, to }: P) => {
  const { t } = useTranslation();

  return (
    <ConfigProvider
      theme={{
        token: {
          linkDecoration: 'none',
          linkHoverDecoration: 'none',
        },
      }}
    >
      <Link
        className={className}
        effects={{ hover: false }}
        onClick={async (event: MouseEvent<HTMLAnchorElement>) => {
          if (onClick) {
            event.preventDefault();
            await onClick();
          }
        }}
        target={target}
        to={to}
      >
        {t(text)}
      </Link>
    </ConfigProvider>
  );
};

export default MenuLinkItem;
